export default {
  SET_NOTIFICATIONS: (state, data) => {
    state.notifications = data;
  },
  SET_UNOPENED_NOTIFICATIONS: (state, data) => {
    state.unopenedNotifications = data;
  },
};
